export const formatLocalDate = (date) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}`;
};

/** Local datetime for APIs that need more than one record per calendar day (e.g. call notes). */
export const formatLocalDateTime = (date) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${formatLocalDate(date)}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

/**
 * Parse a date-only or ISO date string as local calendar date (no timezone shift).
 * Use when API returns "YYYY-MM-DD" or "2025-02-28T00:00:00.000Z" and we need
 * the same calendar date in date pickers / display (e.g. Feb 28 stays Feb 28).
 * @param {string|Date|null|undefined} value - "YYYY-MM-DD", ISO string, or Date
 * @returns {Date|null} - Date at local midnight for that calendar day, or null
 */
export const parseLocalDate = (value) => {
  if (value == null) return null;
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }
  const str = String(value).trim();
  if (!str) return null;
  const datePart = str.includes("T") ? str.split("T")[0] : str;
  const match = datePart.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (!match) return null;
  const [, y, m, d] = match.map(Number);
  const date = new Date(y, m - 1, d);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** Always return YYYY-MM-DD from Date, ISO string, or "YYYY-MM-DD" string. */
export const toYYYYMMDD = (value) => {
  if (value == null) return "";
  const d = value instanceof Date ? value : parseLocalDate(value);
  return d ? formatLocalDate(d) : "";
};
